/**
 * use enum on tutorial component to show tutorial and its status
 */
enum EnumTutorialStatus {
    done = 0,
    welcome = 1,
    downloadApp = 2,
    statisticInfo = 3,
    subscriptionGuide = 4
}

export default EnumTutorialStatus